import { IconComponentType, IconWrapperProps } from './interfaces'
import ChevronLeft from './ChevronLeftIcon'
import Phone from './PhoneIcon'
import Spinner from './SpinnerIcon'
import CheckLine from './CheckLineIcon'
import CreditCard from './CreditCard'
import EmptyCreditCard from './EmptyCreditCard'
import PersonCard from './PersonCard'
import CreditCards from './CreditCards'
import AttentionIcon from './AttentionIcon'
import Flag from './Flag'
import Arrow from './Arrow'
import KashirskayaPlazaCard from './KashirskayaPlazaCard'
import HPCard from './HPCard'
import AppStoreIcon from './AppStoreIcon'
import GooglePlayIcon from './GooglePlayIcon'
import FillPhoneIcon from './FillPhoneIcon'
import EditIcon from './EditIcon'
import ModalSuccessIcon from './ModalSuccessIcon'
import ModalWarningIcon from './ModalWarningIcon'
import CopyIcon from './CopyIcon'
import CheckIcon from './CheckIcon'
import FailedIcon from './FailedIcon'
import CloseIcon from './CloseIcon'
import LocationIcon from './LocationIcon'
import BarrierUpIcon from './BarrierUpIcon'
import SubscriptionIcon from './SubscriptionIcon'
import EventIcon from './EventIcon'
import PhoneHeadsetIcon from './PhoneHeadsetIcon'
import Calendar from './Calendar'
import SearchIcon from './SearchIcon'
import HeadsetWhite from "@/assets/icons/HeadsetWhite";
import ModalCloseIcon from '@/assets/icons/ModalCloseIcon'
import AttentionWhiteIcon from '@/assets/icons/AttentionWhiteIcon'
import DonutSpinnerIcon from "@/assets/icons/DonutSpinnerIcon";

const Icon = ({ name, ...props }: IconWrapperProps) => {
  let Component: IconComponentType
  Component = Spinner

  switch (name) {
    case 'arrow': {
      Component = Arrow
      break
    }
    case 'flag': {
      Component = Flag
      break
    }
    case 'check-line': {
      Component = CheckLine
      break
    }
    case 'chevron-left': {
      Component = ChevronLeft
      break
    }
    case 'phone': {
      Component = Phone
      break
    }
    case 'spinner': {
      Component = Spinner
      break
    }
    case 'credit-card': {
      Component = CreditCard
      break
    }
    case 'empty-credit-card': {
      Component = EmptyCreditCard
      break
    }
    case 'credit-cards': {
      Component = CreditCards
      break
    }
    case 'person-card': {
      Component = PersonCard
      break
    }
    case 'attention-icon': {
      Component = AttentionIcon
      break
    }
    case 'attention-white-icon' : {
      Component = AttentionWhiteIcon
      break
    }
    case 'kashirskaya-plaza-card': {
      Component = KashirskayaPlazaCard
      break
    }
    case 'hp-card': {
      Component = HPCard
      break
    }
    case 'app-store-icon': {
      Component = AppStoreIcon
      break
    }
    case 'google-play-icon': {
      Component = GooglePlayIcon
      break
    }
    case 'fill-phone-icon': {
      Component = FillPhoneIcon
      break
    }
    case 'edit-icon': {
      Component = EditIcon
      break
    }
    case 'modal-success-icon': {
      Component = ModalSuccessIcon
      break
    }
    case 'modal-warning-icon': {
      Component = ModalWarningIcon
      break
    }
    case 'copy-icon': {
      Component = CopyIcon
      break
    }
    case 'check-icon': {
      Component = CheckIcon
      break
    }
    case 'failed-icon': {
      Component = FailedIcon
      break
    }
    case 'close-icon': {
      Component = CloseIcon
      break
    }
    case 'search-icon': {
      Component = SearchIcon
      break
    }
    case 'location-icon': {
      Component = LocationIcon
      break
    }
    case 'barrier-up-icon': {
      Component = BarrierUpIcon
      break
    }
    case 'subscription-icon': {
      Component = SubscriptionIcon
      break
    }
    case 'event-icon': {
      Component = EventIcon
      break
    }
    case 'phone-headset-icon': {
      Component = PhoneHeadsetIcon
      break
    }
    case 'calendar-icon': {
      Component = Calendar
      break
    }
    case 'headset-white': {
      Component = HeadsetWhite
      break
    }
    case 'modal-close-icon': {
      Component = ModalCloseIcon
      break
    }
    case 'donut-spinner': {
      Component = DonutSpinnerIcon
      break
    }
  }

  return <Component {...props} />
}

export default Icon
